import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { API } from "../../lib/storeApi";
import { Lock } from "lucide-react";

const AdminLogin = () => {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      const r = await fetch(`${API}/auth/login`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ email, password }) });
      const d = await r.json();
      if (r.ok && d.token) { localStorage.setItem("sht_admin_token", d.token); nav("/admin"); }
      else setErr(typeof d.detail === "string" ? d.detail : "Login failed");
    } catch (e) { setErr("Login failed"); }
    setBusy(false);
  };

  return (
    <div className="min-h-screen bg-[#0a1f44] flex items-center justify-center px-5" data-testid="admin-login">
      <form onSubmit={submit} className="bg-white rounded-2xl p-8 w-full max-w-sm">
        <div className="w-12 h-12 rounded-full bg-[#3b9dff]/10 flex items-center justify-center mx-auto"><Lock className="w-6 h-6 text-[#3b9dff]" /></div>
        <h1 className="text-2xl font-extrabold text-[#0a1f44] text-center mt-4">Store Admin</h1>
        <p className="text-slate-500 text-sm text-center mt-1">Sign in to manage products</p>
        <input required type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email" className="w-full px-4 py-2.5 border border-slate-300 rounded-lg text-sm mt-5" />
        <input required type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" className="w-full px-4 py-2.5 border border-slate-300 rounded-lg text-sm mt-3" />
        {err && <p className="text-red-500 text-sm mt-3" data-testid="admin-error">{err}</p>}
        <button disabled={busy} data-testid="admin-login-btn" className="w-full bg-[#3b9dff] hover:bg-[#2b8ae8] text-white py-3 rounded-full font-semibold mt-4 disabled:opacity-60">{busy ? "Signing in…" : "Sign In"}</button>
      </form>
    </div>
  );
};

export default AdminLogin;
